// Fees and Billing: the routes and the sidebar rows of `wealth.ops.fees-billing` (ADR-0027).
import { defineWebFeature } from '@/features/kit';

export default defineWebFeature({
    id: 'wealth.ops.fees-billing',
    routes: [
        {
            frontend: 'ops',
            path: 'fees-billing',
            lazy: () => import('@/pages/ops/fees-billing/page'),
        },
    ],
    nav: [
        {
            frontend: 'ops',
            key: 'fees-billing',
            label: 'Fees & Billing',
            href: '/ops/fees-billing',
            icon: 'Receipt',
            group: 'reporting',
            order: 520,
        },
    ],
});
